<template>
  <div class="field-wrapper field-wrapper--textarea"
       :class="['field-wrapper--' + field.size]">
    <div class="field-group field-group--textarea"
         ref="fieldGroup"
         :class="[{'field-group--error': isError}, {'field-group--block-animated': text.length > 0}]">
      <label
        class="label"
        :for="'input_' + formId + '_' + field.id"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>
      <textarea :name="'input_' + field.id"
                v-model="text"
                @input="textareaSize"
                @focus="inputFocus"
                @blur="inputBlur"
                :required="field.isRequired"
                :id="'input_' + formId + '_' + field.id"
                cols="30"
                rows="1"></textarea>
    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import store from '../store';
import VFieldMixins from './VFieldMixins.vue';
export default {
  store,
  name: "VFieldTextarea",
  mixins: [VFieldMixins],
  data () {
    return {
      text: ''
    }
  },
  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    isError: false
  },
  watch: {
    text: {
      immediate: true,
      deep: false,
      handler (newValue) {
        if (newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.fieldGroup.classList.add("field-group--block-focus")
          })
        }

        store.commit(
            "UPDATE_USER_FORM_DATA" ,
            {"key": this.field.id, "value": newValue})
      }
    }
  }
}
</script>
